import { BtnFunction } from '@/components/BtnFunction'

interface FunctionBarProps {
    activeTab: 'overview' | 'analyze'
    onTabChange: (tab: 'overview' | 'analyze') => void
}

export const FunctionBar = ({ activeTab, onTabChange }: FunctionBarProps): JSX.Element => {
    return (
        <div className="relative max-w-[1200px] w-full h-[36px] md:h-[44px] lg:h-[50px] mb-0">
            <BtnFunction
                className="!left-0 !absolute !top-0"
                functionName="近期概況"
                property1={activeTab === 'overview' ? 'btn-function-select' : 'btn-function'}
                onClick={() => onTabChange('overview')}
            />
            <BtnFunction
                className="!left-[140px] md:!left-[200px] lg:!left-[270px] !absolute !top-0"
                functionName="評論分析"
                property1={activeTab === 'analyze' ? 'btn-function-select' : 'btn-function'}
                onClick={() => onTabChange('analyze')}
            />
        </div>
    )
}
